export default __webpack_public_path__ + "static/media/manager.0c34e972.png";